import {bytesToBase64} from './bytes-to-base64';

/**
 * Reads a value the earlier crypto-js format wrote, to migrate it. crypto-js derives its AES key with MD5, which Web
 * Crypto lacks, so this loads crypto-js on demand. Drop it, and crypto-js with it, once those values are migrated.
 *
 * @returns the decrypted payload, or `undefined` when `cipher` does not decrypt with this `secret` and `keyMaterial`
 */
export const decryptLegacy = async (cipher: string, secret: string, keyMaterial: string): Promise<any> => {
    const encoder = new TextEncoder();
    const hmacKey = await crypto.subtle.importKey(
        'raw',
        encoder.encode(keyMaterial),
        {name: 'HMAC', hash: 'SHA-512'},
        false,
        ['sign'],
    );
    const passphrase = bytesToBase64(new Uint8Array(await crypto.subtle.sign('HMAC', hmacKey, encoder.encode(secret))));
    const [{default: AES}, {default: encUtf8}] = await Promise.all([
        import('crypto-js/aes'),
        import('crypto-js/enc-utf8'),
    ]);

    try {
        return JSON.parse(AES.decrypt(cipher, passphrase).toString(encUtf8));
    } catch {
        return undefined;
    }
};
